import React, { useEffect, useRef } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';

export default function Gallery() {
  // Ref for the gallery
  const galleryRef = useRef(null);

  // Animation controls
  const controls = useAnimation();

  // InView hook
  const isInView = useInView(galleryRef, { once: true, threshold: 0.2 });

  // Trigger animations
  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [controls, isInView]);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.div
      ref={galleryRef}
      className="images-row flex flex-col md:flex-row gap-4 justify-center items-center"
      initial="hidden"
      animate={controls}
      variants={containerVariants}
    >
      <motion.div
        className="images-col flex flex-row md:flex-col gap-2 md:gap-4 items-center justify-center"
        variants={containerVariants}
      >
        <motion.img
          src="https://shecluded-medias.s3.us-east-2.amazonaws.com/community-women-4.jpg"
          className="w-1/2 md:w-[250px] lg:w-[300px] h-[120px] md:h-[300px] lg:h-[400px] object-cover rounded-3xl"
          alt="women in the shecluded hub"
          variants={itemVariants}
        />
        <motion.img
          src="https://shecluded-medias.s3.us-east-2.amazonaws.com/Frame+1000004546.png"
          className="w-1/2 md:w-[250px] lg:w-[300px] h-[120px] md:h-[150px] lg:h-[200px] object-cover rounded-3xl"
          alt="women in the shecluded hub"
          variants={itemVariants}
        />
      </motion.div>
      <motion.div
        className="images-col flex flex-row md:flex-row gap-2 md:gap-4 items-center justify-center"
        variants={containerVariants}
      >
        <motion.img
          src="https://shecluded-medias.s3.us-east-2.amazonaws.com/community-women-2.jpg"
          className="w-1/2 md:w-[250px] lg:w-[300px] h-[150px] md:h-[460px] lg:h-[620px] object-cover rounded-3xl"
          alt="women in the shecluded hub"
          variants={itemVariants}
        />
        <motion.video
          src="https://shecluded-medias.s3.us-east-2.amazonaws.com/community-video.mp4"
          className="w-1/2 md:w-[250px] lg:w-[300px] h-[150px] md:h-[460px] lg:h-[620px] object-cover rounded-3xl"
          loop
          autoPlay
          muted
          variants={itemVariants}
        />
      </motion.div>
      <motion.div
        className="images-col flex flex-row md:flex-col gap-2 md:gap-4 items-center justify-center"
        variants={containerVariants}
      >
        <motion.img
          src="https://shecluded-medias.s3.us-east-2.amazonaws.com/Frame+1000004550-2.png"
          className="w-1/2 md:w-[250px] lg:w-[250px] h-[120px] md:h-[150px] lg:h-[200px] object-cover rounded-3xl"
          alt="women in the shecluded hub"
          variants={itemVariants}
        />
        <motion.img
          src="https://shecluded-medias.s3.us-east-2.amazonaws.com/Frame+1000004549.png"
          className="w-1/2 md:w-[250px] lg:w-[250px] h-[120px] md:h-[300px] lg:h-[400px] object-cover rounded-3xl"
          alt="women in the shecluded hub"
          variants={itemVariants}
        />
      </motion.div>
    </motion.div>
  );
}
